import * as React from 'react';
import { observer } from 'mobx-react';

interface ILoadingProps {
    hidden?: boolean;
    className?: string;
}

export class Loading extends React.Component<ILoadingProps> {
    public render(): React.ReactNode {
        const className = this.props.className ? `loading-screen ${this.props.className}` : 'loading-screen';
        return (
            <div className={className} hidden={this.props.hidden}>
                <i className="icon-animate-spin icon-spin" />
                <span>Loading</span>
            </div>
        );
    }
}

export default observer(Loading);